module.exports = __webpack_public_path__ + "img/big_1_80.904c0b4f.png";